import Image from "next/image";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import FillLikeIcon from "../../../../../../../shared-assets/images/funUgc/player/FillLikeIcon.png";
import OutlineLikeIcon from "../../../../../../../shared-assets/images/funUgc/player/OutlineLikeIcon.png";
import { UGCList } from "../../../../../../models/home-rows";
import { API } from "../../../../../../services/api-services";
import AppContext from "../../../../../../services/app-context-services";
import { _ } from "../../../../../../services/text-services";
import FetchData from "../../../../../shared/fetch-data/fetch-data";
import styles from "./ProductLike.module.scss";

interface ProductLikeProps {
  ugc: UGCList;
  rowMode: number;
}

export function ProductLike({ ugc, rowMode }: ProductLikeProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [fetchPost, setFetchPost] = useState(false);
  const [fetchDelete, setFetchDelete] = useState(false);
  const [isLike, setIsLike] = useState<boolean>();
  const [totalLikes, setTotalLikes] = useState<number | null>();
  const { isLoggedIn, setShowLoginPopup } = useContext(AppContext);

  const router = useRouter();

  const updateLocalStorage = (ugcId: number, isLiked: boolean) => {
    let likesData = JSON.parse(localStorage.getItem("userLikes") || "[]");
    const index = likesData.findIndex(
      (item: { ugcId: number; isLiked: boolean }) => item.ugcId === ugcId
    );

    if (isLiked) {
      if (index > -1) {
        likesData[index].isLiked = true;
      } else {
        likesData.push({ ugcId, isLiked: true });
      }
    } else {
      if (index > -1) {
        likesData.splice(index, 1);
      }
    }

    localStorage.setItem("userLikes", JSON.stringify(likesData));
  };

  useEffect(() => {
    setFetchPost(false);
    setFetchDelete(false);
  }, [fetchDelete, fetchPost]);

  useEffect(() => {
    const likesData = JSON.parse(localStorage.getItem("userLikes") || "[]");
    const likedItem = likesData.find(
      (item: { ugcId: number; isLiked: boolean }) => item.ugcId === ugc.id
    );
    if (likedItem) {
      setIsLike(likedItem.isLiked);
    }
  }, [ugc.id]);

  useEffect(() => {
    setTotalLikes(ugc?.total_likes);
  }, [ugc]);

  return (
    <>
      {fetchPost && isLike && (
        <FetchData
          url={API.post_like(ugc.id)}
          method="POST"
          pendingHandlerSetter={setIsLoading}
        />
      )}

      {fetchDelete && !isLike && (
        <FetchData
          url={API.remove_like(ugc.id)}
          method="DELETE"
          pendingHandlerSetter={setIsLoading}
        />
      )}

      <div
        className={styles.productLikeWrapper}
        onClick={() => {
          if (!isLoggedIn) {
            setShowLoginPopup(true);
            router.push({
              pathname: "/",
              query: { ugcId: ugc.id, rowMode: rowMode }
            });
          } else {
            if (isLike) {
              setFetchDelete(true);
              setIsLike(false);
              setTotalLikes(c => (c as number) - 1);
              updateLocalStorage(ugc.id, false);
            } else {
              setFetchPost(true);
              setIsLike(true);
              setTotalLikes(c => (c as number) + 1);
              updateLocalStorage(ugc.id, true);
            }
          }
        }}
      >
        <div className={styles.likeImageWrapper}>
          {isLike === true ? (
            <Image src={FillLikeIcon} alt="" layout="fill" priority={true} />
          ) : (
            <Image src={OutlineLikeIcon} alt="" layout="fill" priority={true} />
          )}
        </div>
        <div className={styles.likeNumber}>
          {totalLikes <= 0 ? _(0) : _(totalLikes)}
        </div>
      </div>
    </>
  );
}
